__turbopack_context__.v({
  "actionError": "TaskWorkspace-module__6NS4wa__actionError",
  "actionsCell": "TaskWorkspace-module__6NS4wa__actionsCell",
  "actionsHeading": "TaskWorkspace-module__6NS4wa__actionsHeading",
  "categoryCount": "TaskWorkspace-module__6NS4wa__categoryCount",
  "categoryName": "TaskWorkspace-module__6NS4wa__categoryName",
  "clearSearchButton": "TaskWorkspace-module__6NS4wa__clearSearchButton",
  "disclosureIcon": "TaskWorkspace-module__6NS4wa__disclosureIcon",
  "logsButton": "TaskWorkspace-module__6NS4wa__logsButton",
  "noSearchResults": "TaskWorkspace-module__6NS4wa__noSearchResults",
  "noSearchResultsIcon": "TaskWorkspace-module__6NS4wa__noSearchResultsIcon",
  "page": "TaskWorkspace-module__6NS4wa__page",
  "pageHeader": "TaskWorkspace-module__6NS4wa__pageHeader",
  "retryButton": "TaskWorkspace-module__6NS4wa__retryButton",
  "searchField": "TaskWorkspace-module__6NS4wa__searchField",
  "searchIcon": "TaskWorkspace-module__6NS4wa__searchIcon",
  "searchInput": "TaskWorkspace-module__6NS4wa__searchInput",
  "searchToolbar": "TaskWorkspace-module__6NS4wa__searchToolbar",
  "spin": "TaskWorkspace-module__6NS4wa__spin",
  "spinner": "TaskWorkspace-module__6NS4wa__spinner",
  "srOnly": "TaskWorkspace-module__6NS4wa__srOnly",
  "stateIcon": "TaskWorkspace-module__6NS4wa__stateIcon",
  "statePanel": "TaskWorkspace-module__6NS4wa__statePanel",
  "statusBadge": "TaskWorkspace-module__6NS4wa__statusBadge",
  "statusFilter": "TaskWorkspace-module__6NS4wa__statusFilter",
  "statusMark": "TaskWorkspace-module__6NS4wa__statusMark",
  "tableScroller": "TaskWorkspace-module__6NS4wa__tableScroller",
  "taskActionButton": "TaskWorkspace-module__6NS4wa__taskActionButton",
  "taskActions": "TaskWorkspace-module__6NS4wa__taskActions",
  "taskDate": "TaskWorkspace-module__6NS4wa__taskDate",
  "taskGroup": "TaskWorkspace-module__6NS4wa__taskGroup",
  "taskGroups": "TaskWorkspace-module__6NS4wa__taskGroups",
  "taskId": "TaskWorkspace-module__6NS4wa__taskId",
  "taskList": "TaskWorkspace-module__6NS4wa__taskList",
  "taskListTitle": "TaskWorkspace-module__6NS4wa__taskListTitle",
  "taskTable": "TaskWorkspace-module__6NS4wa__taskTable",
  "titleRow": "TaskWorkspace-module__6NS4wa__titleRow",
  "toolbarEnd": "TaskWorkspace-module__6NS4wa__toolbarEnd",
});
